import axios from 'axios';
import Orders from '../services/Orders';
import { receiveApiError } from './errors';
import { receiveOrders } from './orders';
// import { STATUS } from '../helpers/constants';
import createSubscribeAction from '../helpers/createSubscribeAction';
const CancelToken = axios.CancelToken;

export const LOADING_ORDER = 'LOADING_ORDER';
export const SELECT_ORDER = 'SELECT_ORDER';
export const RECEIVE_ORDER = 'RECEIVE_ORDER';
export const UPDATE_ORDER = 'UPDATE_ORDER';

export function loadingOrder(idOrder) {
  return {
    type: LOADING_ORDER,
    idOrder,
  };
}

export function receiveOrder(order) {
  return {
    type: RECEIVE_ORDER,
    order,
  };
}

export function selectOrder(idOrder) {
  return {
    type: SELECT_ORDER,
    idOrder,
  };
}

export function updateOrder(order) {
  return {
    type: UPDATE_ORDER,
    order,
  };
}

export function getOrder(idOrder, cancelToken) {
  return dispatch => {
    dispatch(loadingOrder(idOrder));
    return Orders.getById(idOrder, cancelToken)
      .then(resp => {
        dispatch(receiveOrder(resp.data));
      })
      .catch(err => {
        dispatch(receiveApiError(err));
      });
  };
}

export const START_SUBSCRIBE_ORDER = 'START_SUBSCRIBE_ORDER';
export const CANCEL_SUBSCRIBE_ORDER = 'CANCEL_SUBSCRIBE_ORDER';

export function startSubscribeOrder(id) {
  return {
    type: START_SUBSCRIBE_ORDER,
    id,
  };
}

export function cancelSubscribeOrder(id) {
  return {
    type: CANCEL_SUBSCRIBE_ORDER,
    id,
  };
}

/**
 *
 * @param idOrder
 * @param interval seconds
 * @returns {function(*=): Function}
 */
export const subscribeOrder = (idOrder, interval) => {
  return createSubscribeAction((dispatch, id) => {
    let lastResponse;
    let source;
    dispatch(startSubscribeOrder(id));
    dispatch(loadingOrder(idOrder));
    return {
      async call() {
        source = CancelToken.source();
        try {
          const { data, request } = await Orders.getById(idOrder, source.token);
          if (request.response !== lastResponse) {
            lastResponse = request.response;
            dispatch(receiveOrder(data));
          }
        } catch (error) {
          dispatch(receiveApiError(error));
        }
      },
      cancel() {
        if (source) {
          source.cancel('unsubscribed');
        }
        dispatch(cancelSubscribeOrder(id));
      },
    };
  }, interval);
};

export function putOrder(idOrder, data) {
  return (dispatch, getState) => {
    const orders = getState().orders.orders;
    Orders.update(idOrder, data)
      .then(() => {
        dispatch(updateOrder({ id: idOrder, ...data }));
        const ordersUpdated = orders.map(item => {
          if (item.id === idOrder) {
            item.status = data.status; //eslint-disable-line
          }
          return item;
        });
        dispatch(receiveOrders(ordersUpdated));
        // dispatch
        // (getOrdersByStatusNotLoading(STATUS.filter((s) => { return s.id === data.status; })[0]));
      })
      .catch(err => {
        console.log(err);
        dispatch(receiveApiError(err));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/order.js